import { useDispatch as useDispatchOrg, useSelector as useSelectorOrg } from "react-redux";
export const useDispatch = useDispatchOrg;
export const useSelector = useSelectorOrg;
//# sourceMappingURL=reduxHooks.js.map